
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Database } from "@/integrations/supabase/types";

type Profile = Database["public"]["Tables"]["profiles"]["Row"];
type Coin = Database["public"]["Tables"]["coins"]["Row"];
type SystemConfig = Database["public"]["Tables"]["system_config"]["Row"];

export function useAdminData() {
    const [users, setUsers] = useState<Profile[]>([]);
    const [coins, setCoins] = useState<Coin[]>([]);
    const [config, setConfig] = useState<SystemConfig | null>(null);
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        setLoading(true);
        try {
            const [usersResult, coinsResult, configResult] = await Promise.all([
                supabase.from("profiles").select("*").limit(50),
                supabase.from("coins").select("*").limit(50),
                supabase.from("system_config").select("*").limit(1).maybeSingle(),
            ]);

            if (usersResult.data) setUsers(usersResult.data);
            if (coinsResult.data) setCoins(coinsResult.data);
            if (configResult.data) setConfig(configResult.data);

        } catch (error) {
            console.error("Failed to fetch admin data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return { users, coins, config, refetch: fetchData, loading };
}
